export { DirectiveModule } from './directive.module';
